import ItemRequest from '@/http/ItemRequest'
import ErrorResponseHandler from '@/utility/ErrorResponseHandler'

const item = {
  namespaced: true,
  state: {
    items: [],
    tagToItems: [], // タグに紐づく商品リスト
    itemToTags: [], // 商品に紐づくタグリスト
    kinds: [], // 商品提供形態（製造区分）
    toppings: [], // トッピング一覧
  },
  getters: {
    getItems: (state) => {
      return state.items
    },
    getItemById: (state) => (id) => {
      const item = state.items.list.find((item) => {
        return item.itemCode === id
      })
      return item || null
    },
    getTagToItems: (state) => {
      return state.tagToItems
    },
    getItemToTags: (state) => {
      return state.itemToTags
    },
    getKinds: (state) => state.kinds,
    getToppings: (state) => state.toppings,
  },
  actions: {
    getItems: ({ commit }) => {
      const request = new ItemRequest()
      request
        .getList()
        .then((res) => {
          commit('setItems', res.data)
        })
        .catch((err) => {
          ErrorResponseHandler.redirectErrorPage(err.response)
        })
    },
    getTags: ({ commit }) => {
      const request = new ItemRequest()
      request
        .getTags()
        .then((res) => {
          commit('setTags', res.data)
        })
        .catch((err) => {
          ErrorResponseHandler.redirectErrorPage(err.response)
        })
    },
    fetchKinds: ({ commit }) => {
      const request = new ItemRequest()
      request
        .getKinds()
        .then((res) => {
          commit('setKinds', res.data.list)
        })
        .catch((err) => {
          ErrorResponseHandler.redirectErrorPage(err.response)
        })
    },
    fetchToppings: ({ commit }) => {
      const request = new ItemRequest()
      request
        .getToppings()
        .then((res) => {
          commit('setToppings', res.data.list)
        })
        .catch((err) => {
          ErrorResponseHandler.redirectErrorPage(err.response)
        })
    },
  },
  mutations: {
    setItems(state, items) {
      state.items = items
    },
    setTags(state, response) {
      state.tagToItems = response.tags
      state.itemToTags = response.items
    },
    setKinds(state, kinds) {
      state.kinds = kinds
    },
    setToppings(state, toppings) {
      state.toppings = toppings
    },
  },
}

export default item
